import React, { useState } from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle, Typography, Button } from '@mui/material'
import { deletePycodesCombination } from 'utils/PaycodesCombination'
import { useTranslation } from 'react-i18next'

type AlertSeverity = 'success' | 'error' | 'warning' | 'info'

interface Props {
    open: boolean
    setOpenDelete: React.Dispatch<React.SetStateAction<boolean>>
    setAlert: React.Dispatch<React.SetStateAction<{ msg: string; severity: AlertSeverity }>>
    setOpenAlert: React.Dispatch<React.SetStateAction<boolean>>
    selectedRow: number[]
    setSelected: () => void
    reloading: () => void
}

const DeletePaycodesCombination = ({ open, setOpenDelete, setAlert, setOpenAlert, selectedRow, setSelected, reloading }: Props) => {
    const { t } = useTranslation()

    const [loading, setLoading] = useState(false)

    return (
        <Dialog
            open={open}
            onClose={() => setOpenDelete(false)}
        >
            <DialogTitle>
                <Typography variant='body1'>{t('settings.paycodes_combination.dialog.titles.delete')}</Typography>
            </DialogTitle>

            <DialogContent>
                <Typography variant='body1'>
                    {t('settings.paycodes_combination.dialog.alerts.delete.message')}
                </Typography>
            </DialogContent>

            <DialogActions sx={{ pb: 2, pr: 3 }}>
                <Button
                    variant='contained'
                    disableElevation
                    onClick={() => {
                        deletePycodesCombination(setLoading, selectedRow)
                            .then(() => {
                                setOpenDelete(false)
                                setAlert({ msg: t('settings.paycodes_combination.dialog.alerts.delete.success'), severity: 'success' })
                                setOpenAlert(true)
                                reloading()
                                setSelected()
                            })
                            .catch((error: unknown) => {
                                console.error(error)
                            })
                    }}
                    color='error'
                    loading={loading}
                >
                    {t('general.buttons.delete')}
                </Button>
                <Button
                    variant='outlined'
                    onClick={() => setOpenDelete(false)}
                >
                    {t('general.buttons.cancel')}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export { DeletePaycodesCombination }
